<template>
  <div class="da_entreprise_groups">

    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>


    <div class="w-80 mx-md-auto mb-6 text-center">
      <button type="button" class="btn btn-primary" @click="add_group">
        <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;
        <span v-if="admin">Ajouter un groupe</span>
        <span v-else>Proposer un groupe</span>
      </button>
    </div>

    <div class="modal fade" id="group_modal" tabindex="-1" role="dialog" aria-labelledby="group_modal_label" aria-hidden="true">
      <form method="post" @submit.prevent="post_group" id="group_form" enctype="multipart/form-data">
        <input type="hidden" name="method" :value="method">
        <input type="hidden" name="id" :value="group_id">
        
        <div class="modal-dialog modal-lg modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title text-primary" id="group_modal_label">{{group_modal_title}}</h5>

              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <button type="submit" class="btn btn-primary float-right" name="editGroup">
                <i class="fa fa-save" aria-hidden="true"></i>
                Enregistrer
              </button>

              <div class="form-group">
                <label for="name" class="col-form-label">Nom :</label>
                <input id="name" type="text" class="form-control" name="name" v-model="group_name">
              </div>

              <div class="required form-group">
                <label for="description">
                  Description :
                </label>

                <ckeditor :editor="editor" v-model="group_description" :config="editor_config" name="description">
                </ckeditor>

                <div class="invalid-feedback">
                  La description doit contenir 3 et 400 caractères.
                </div>
              </div>

              <div class="form-group">
                <label for="group_type_id" class="col-form-label">Famille de groupe</label>
                <select class="custom-select" name="group_type_id" id="group_type_id">
                  <option>Séléctionner une famille de groupe</option>
                  <option v-for="type in group_types"
                          :key="type.id"
                          :value="type.id"
                          :selected="type.id == group_type_id ? true : false">
                    {{ type.name }}
                  </option>
                </select>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="1" id="private" name="private" v-model="group_private">
                <label class="form-check-label" for="private">
                  Privée (Le groupe n'apparaitra pas dans la liste des groupes)
                </label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="checkbox" value="1" id="private_registration"
                       name="private_registration" v-model="group_private_registration">
                <label class="form-check-label" for="private_registration">
                  Enregistrement privé (L'adhésion au groupe devra être validé par l'administrateur du groupe)
                </label>
              </div>

              <div v-if="admin" class="form-check">
                <input class="form-check-input" type="checkbox" value="1" id="homepage" name="homepage" v-model="group_homepage">
                <label class="form-check-label" for="homepage">
                  Visible sur la page d'accueil
                </label>
              </div>

              <dlnk-clipper :crop_ratio="0.28"></dlnk-clipper>

              <div class="form-group mt-2">
                <a id="changePictureBtn" href="javascript:"
                   data-toggle="modal" data-target="#changePictureModal" class="btn btn-primary ml-1 mb-1">
                  Changer la photo
                </a>
              </div>

              <div class="col-12">
                <input type="hidden" name="photo_cam" id="photo_cam" value="">
                <img id="preview_photo" :src="group_image_url" alt="" height="100px">
              </div>

            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>
                Annuler
              </button>
              <button type="submit" class="btn btn-primary" name="editGroup">
                <i class="fa fa-save" aria-hidden="true"></i>
                Enregistrer
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="position-relative bg-primary overflow-hidden">
      <div class="container mt-2 position-relative z-index-2 mb-5">
        <div class="w-xl-50 w-md-80 mx-auto">
          <input type="text" placeholder="Rechercher ..." class="form-control-sm w-100 border"
                 v-on:keyup="search_groups"
                 v-model="query">
        </div>
      </div>

      <div class="container mb-3">
        <div id="sortByTheme" class="w-xl-80 mx-xl-auto">
          <span class="text-white">Catégories :</span>

          <a class="badge badge-light text-left mb-2 active"
            href="javascript:" id="group-type-0" @click="toggle_group_type(0)">
            Toutes
          </a>

          <a class="badge badge-light text-left mx-1 mb-2"
            :id="'group-type-' + current_type.id"
            href="javascript:"
            v-for="current_type in current_group_types"
            :key="current_type.id" @click="toggle_group_type(current_type.id)">
            {{current_type.name}}
          </a>
        </div>
      </div>

      <div class="container space-top-1 position-relative z-index-2">
        <div class="w-xl-80 mx-xl-auto">
          <nav aria-label="Page navigation">
            <ul class="pagination justify-content-between align-items-center">
              <li class="page-item ml-0" v-bind:class="{ disabled: page === 1 }">
                <a class="btn btn-secondary btn-sm"
                   href="javascript:"
                   v-on:click="previous_page"
                   aria-label="Précédent">
                  <span aria-hidden="true">« Précédent</span>
                  <span class="sr-only">Précédent</span>
                </a>
              </li>
              <li class="page-item">
                <div class="d-flex align-items-center">
                  <span class="d-none d-sm-inline-block text-white">Page&nbsp;</span>
                  <span class="d-none d-sm-inline-block text-white">
												{{ page }} sur {{ page_count }}
										</span>
                </div>
              </li>
              <li class="page-item {if $groups_page_number == $groups_page_count}disabled{/if}">
                <a class="btn btn-secondary"
                   aria-label="Suivant"
                   v-on:click="next_page"
                   href="javascript:">
                  <span aria-hidden="true">Suivant »</span>
                  <span class="sr-only">Suivant</span>
                </a>
              </li>
            </ul>
          </nav>

          <daentreprise-group
              v-for="group in groups"
              :key="group.id"
              :admin="admin"
              :group="group"
              :customer_id="customer_id"
              :status="my_groups[group.id]"
              :my_groups="my_groups"
              :group_type="Number(type_id)"
              @edit_group="edit_group($event)"
              @delete_group="delete_group($event)">
          </daentreprise-group>

        </div>
      </div>

    </div>

  </div>
</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  props: [
    'admin',
    'customer_id'
  ],

  data: function () {
    return {
      groups: [],
      my_groups: [],
      group_types: [],
      current_group_types: [],
      group_count: 0,
      group_modal_title: String,
      group_type_id: Number,
      group_homepage: Boolean,
      group_private: Boolean,
      group_private_registration: Boolean,
      group_image_url: String,
      page: Number(1),
      page_count: 1,
      query: '',
      type_id: 0,
      message: '',
      message_type: '',
      method: 'post',
      group_id: 0,
      group_name: "",
      group_description: "",
      editor: ClassicEditor,
      editor_config: {
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ],
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' }
          ]
        }
      }
    }
  },

  mounted() {
    this.get_data()
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    previous_page: function () {
      let _this = this;

      if (Number(_this.page) > 1) {
        _this.page = Number(_this.page) - 1;
        _this.get_data();
      }
    },

    toggle_group_type: function (group_type_id) {
      this.type_id = group_type_id;

      this.page = 1;
      this.get_data();

      $('#sortByTheme').children().removeClass('active');
      $('#sortByTheme').children( '#group-type-' + group_type_id ).addClass('active');
    },

    post_group: function () {
      const _this = this;
      const url = '/modules/daentreprise/actions/groups.php';

      const form_element = document.getElementById("group_form");
      const form_data = new FormData(form_element);
      form_data.append('description', _this.group_description)

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data'}
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              $('#group_modal').modal('hide');
              _this.get_data();
              if(_this.method === 'post') {
                if (_this.admin) {
                  _this.message = "Groupe ajouté.";
                } else {
                  _this.message = "Votre groupe a été proposé. Il sera bientôt validé par un administrateur.";
                }
              } else {
                _this.message = "Groupe modifié.";
              }
              _this.message_type = "alert-success"
            } else {
              _this.message = response.data.errors;
              _this.message_type = "alert-danger";
            }
          })
          .catch(function (response) {
            alert('Erreur inconnu');
          });
    },

    add_group: function() {
      this.method = 'post'
      this.group_id = null;
      this.group_type_id = null;
      this.group_name = null;
      this.group_description = "";
      this.group_homepage = false;
      this.group_private = false;
      this.group_private_registration = false;
      this.group_image_url = false;
      this.group_modal_title = 'Ajouter un groupe';

      $('#group_modal').modal('show');
    },

    edit_group: function(group) {

      this.group_id = group.id;
      this.group_name = group.name;
      this.group_description = group.description || "";
      this.group_homepage = !!parseInt(group.homepage);
      this.group_private = !!parseInt(group.private);
      this.group_private_registration = !!parseInt(group.private_registration);
      this.group_image_url = group.image_url;
      this.group_modal_title = 'Modifier un groupe';
      this.group_type_id = Number(group.group_type_id);

      this.method = 'patch'

      $('#group_modal').modal('show');
    },
    delete_group: function (group_id) {

      const _this = this;
      const url = '/modules/daentreprise/actions/groups.php/' + group_id;

      axios({
        method: 'delete',
        url: url,
        headers: {}
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              _this.get_data();
              _this.message = "Groupe supprimé.";
              _this.message_type = "alert-success"
            } else {
              _this.message = response.data.errors;
              _this.message_type = "alert-danger";
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    next_page: function () {

      let _this = this;

      if (_this.page < _this.page_count) {
        _this.page = Number(_this.page) + 1;
        _this.get_data();
      }
    },

    get_data: function () {
      let _this = this;

      let url = '/modules/daentreprise/actions/groups.php?page=' + _this.page;
      url += '&query=' + _this.query + '&type_id=' + _this.type_id

      axios.get(url)
          .then(function (response) {
            _this.groups = response.data.groups
            _this.my_groups = response.data.my_groups
            _this.group_count = response.data.group_count
            _this.page = response.data.page
            _this.page_count = response.data.page_count
            _this.group_types = response.data.group_types
            _this.current_group_types = response.data.current_group_types
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    search_groups() {
      this.get_data();
    }

  }
}

</script>
